module.exports = __webpack_public_path__ + "media/img/frontend_application/controls-cf74dc23d605416e8b7d16cde74ba75a.png";